// This function filters Drupal form data, marking form fields and CTAs as unique.
export const drupalFormFilter = (data, type) => {
  // Array to store unique form field and CTA components
  const updatedDataArray = [];
  // Variables to track the form index and update status
  let formIndex = 0,
    indexUpdated = false;
  // Filter data and identify form fields and CTAs
  const updatedData = data?.filter((item, index) => {
    if (
      item.type === "form_field_component" ||
      item.type === "form_cta_component"
    ) {
      item.uniqueFormValue = true;
      updatedDataArray?.push(item);
      if (!indexUpdated) {
        formIndex = index;
        indexUpdated = true;
      }
      return false;
    } else {
      return true;
    }
  });
  // Created an object with type and the array of identified components
  const newFormDataObject = { type, uniqueFormData: updatedDataArray };
  // Create a new array
  const newDataArray = [
    ...updatedData.slice(0, formIndex),
    newFormDataObject,
    ...updatedData.slice(formIndex),
  ];
  // Returning new array
  return newDataArray;
};

// This function filters Drupal form data, marking form fields and CTAs as unique.
export const drupalComponentGrouper = (data, type) => {
  // Array to store unique form field and CTA components
  const updatedDataArray = [];
  // Variables to track the form index and update status
  let index = 0,
    indexUpdated = false;
  // Filter data and identify form fields and CTAs
  const updatedData = data?.filter((item, i) => {
    if (item.type === type) {
      item.uniqueValue = true;
      updatedDataArray?.push(item);
      if (!indexUpdated) {
        index = i;
        indexUpdated = true;
      }
      return false;
    } else {
      return true;
    }
  });
  // Created an object with type and the array of identified components
  const newDataObject = { type, uniqueData: updatedDataArray };
  // Create a new array
  const newDataArray = [
    ...updatedData.slice(0, index),
    newDataObject,
    ...updatedData.slice(index),
  ];
  // Returning new array
  return newDataArray;
};
